<div class="wrap">
  <div class="wrap__container">
    <div class="container">
      <div class="container__text">
        <p class="text">夢に向かって<br />進んでいけますように</p>
      </div>
      <div class="container__button">
        <a
          routerLink="/about"
          class="button"
          >絵本ができるまで</a
        >
      </div>
    </div>
  </div>
</div>
